import React from 'react';


import { Home } from '../Home/Home';
import { HomeMobile } from '../Home/HomeMobile';


import { About } from "../Biografie/About";
import { Releases } from "../Releases/Releases";

import { Kontakt } from "../Kontakt/Kontakt";
import { Events } from "../Events/Events";
import { Impressum } from "../Impressum/Impressum";
import { useState, useRef } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Newletter } from '../Newsletter';




export const Main = (props) => {
	const isMobile = props.width < 800;
	const [tab, setTab] = useState(0);

	const contentRef = useRef(null);


	const handleChange = (event, newValue) => {
		if (newValue === 4) {
			window.open('https://drive.google.com/drive/u/1/folders/11V__e8ASwZttEmEPUIAbfB3vwQXfAMT3', '_blank'); // open in new window
			return; // stop updating the tab state
		}

		setTab(newValue);


		// wait for content to render
		setTimeout(() => {
			contentRef.current?.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}, 0);
	};

	return (
		<div>
			{isMobile ? <HomeMobile /> : <Home />}


			<Box

				className={isMobile ? 'tabs-mobile' : 'tabs-desktop'}
			>
				<div
					className={`tabs-container ${isMobile ? '' : 'tabs-sticky'}`}

				> 

					<Tabs
						value={tab}
						onChange={handleChange}
						orientation={isMobile ? 'vertical' : 'horizontal'}
						variant={isMobile ? 'standard' : 'scrollable'}
						sx={{
							width: '100%',
							borderColor: 'divider',
							backgroundColor: '#fff',
							// Target all tabs
							'& .MuiTab-root': {
								color: '#999',           // default color
								'&.Mui-selected': {
									color: '#10346e',      // selected tab color
								},
							},
						}}
						slotProps={{
							indicator: {
								sx: {
									backgroundColor: '#10346e', // underline indicator color
								},
							},
						}}
					>
						<Tab label="Bio" />
						<Tab label="Releases" />
						<Tab label="Events" />
						<Tab label="Newsletter" />
						<Tab label="EPK" />
						<Tab label="Kontakt" />
					</Tabs>


				</div>

				<Box sx={{ p: 3 }} ref={contentRef}>
					{tab === 0 && <About />}
					{tab === 1 && <Releases />}
					{tab === 2 && <Events />}
					{tab === 3 && <Newletter />}
					{tab === 5 && <Kontakt />}
				</Box>
			</Box>

			<Impressum />
		</div>
	);
}

